import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import SignUpChoice from "./pages/SignUpChoice";
import MyAssets from "./pages/MyAssets"; 
import StyleUAI from "./pages/StyleUAI";
import Outputs from "./pages/Outputs";   
import MyProfile from "./pages/MyProfile";
import SeoContent from "./pages/SeoContent";
import BgRemover from "./pages/BgRemover";
import BgGenerator from "./pages/BgGenerator";
import ImageEnhancer from "./pages/ImageEnhancer";
import Influencer from "./pages/Influencer";
import PricingPlan from "./pages/PricingPlan";
import InfluencerDetail from "./components/InfluencerDetail";
import VideoGenerator from "./pages/VideoGenerator"; // ✅ NEW import
import InfluencerForm from "./pages/InfluencerForm";
import Sidebar from "./components/Sidebar";

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="signup-option" element={<SignUpChoice />} />
        <Route path="/signup/brand" element={<Signup />} />
        <Route path="/influencer/form" element={<InfluencerForm />} />
        <Route path="/myassets" element={<MyAssets />} />
        <Route path="/styleuai" element={<StyleUAI />} />
        <Route path="/bgremover" element={<BgRemover />} />
        <Route path="/imageenhancer" element={<ImageEnhancer />} />
        <Route path="/bggenerator" element={<BgGenerator />} />
        <Route path="/seocontent" element={<SeoContent />} />
        <Route path="/influencer" element={<Influencer />} />
        <Route path="/outputs" element={<Outputs />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/PricingPlan" element={<PricingPlan />} />
        <Route path="/influencer/:id" element={<InfluencerDetail />} />
        <Route path="/video-generator" element={<VideoGenerator />} /> 
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </Router>
  );
}

export default App;
